import { render, staticRenderFns } from "./book1.vue?vue&type=template&id=54b26c1c&scoped=true&"
import script from "./book1.vue?vue&type=script&lang=js&"
export * from "./book1.vue?vue&type=script&lang=js&"
import style0 from "./book1.vue?vue&type=style&index=0&id=54b26c1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b26c1c",
  null
  
)

export default component.exports